import { createI18n } from "vue-i18n";
import { messages } from "@/shared/i18n";
import { DEFAULT_LANGUAGE_TAG } from "@/shared/utils/localeUtils.ts";
/**
 * Vue i18n Plugin Configuration
 *
 * IMPORTANT: This plugin initializes with DEFAULT_LANGUAGE_TAG (fr-FR).
 * The Language Store (Pinia) will update the locale immediately after initialization
 * based on the following priority:
 *   1. localStorage (user's previous choice)
 *   2. navigator.language (browser locale detection)
 *   3. Keycloak token (if authenticated)
 *   4. API/Organization settings (for public pages)
 *
 * This design ensures:
 *   - Single source of truth for locale detection (Language Store only)
 *   - No duplicate navigator.language calls
 *   - Consistent normalization (only in Language Store)
 *   - Clear separation: i18n is passive, Language Store is active
 */
// Hierarchical fallback configuration: regional → base language → french
// Example: fr-CA → fr, fr-FR → fr, en-US → en → fr
const i18n = createI18n({
    locale: DEFAULT_LANGUAGE_TAG, // Start with fr-FR, Language Store will update
    fallbackLocale: {
        "fr-CA": ["fr"],
        "fr-FR": ["fr"],
        "en-US": ["en", "fr"],
        "en-GB": ["en", "fr"],
        "nl-NL": ["nl", "fr"],
        default: ["fr"],
    },
    messages: messages,
    legacy: false, // Use Composition API
    globalInjection: true,
    warnHtmlMessage: false,
    missingWarn: true, // Warn when a key is missing from ALL locales
    fallbackWarn: false, // Silence warnings when a key is resolved via fallback locale
});
export default i18n;
